export default __webpack_public_path__ + "static/media/logo-bernard.92d10c75.svg";